import React from "react";
import { motion } from "framer-motion";
import {
  CodeIcon,
  DeviceMobileIcon,
  CubeTransparentIcon,
  LightBulbIcon,
} from "@heroicons/react/solid";

const services = [
  {
    icon: CodeIcon,
    title: "Web & Mobile App Development",
    description:
      "Custom web and mobile products built end-to-end, from UI to database, using React, React Native, and modern backend stacks.",
    span: "lg:col-span-2",
  },
  {
    icon: CubeTransparentIcon,
    title: "API & Microservices Architecture",
    description:
      "Scalable REST APIs and microservices architecture designed for reliability, security, and growth.",
    span: "",
  },
  {
    icon: LightBulbIcon,
    title: "Technical Consulting & MVP Builds",
    description:
      "From idea to launch: technical strategy, architecture decisions, and rapid MVP builds for founders and product teams.",
    span: "",
  },
  {
    icon: DeviceMobileIcon,
    title: "Fintech, Identity & Marketplace Platforms",
    description:
      "Deep experience building fintech, identity-verification, and marketplace platforms shipped to real users in Nigeria, Canada, and Europe.",
    span: "lg:col-span-2",
  },
];

const CodehouzeServices = () => {
  return (
    <section id="services" className="py-24 bg-gray-900/50 relative">
      <div className="mx-auto max-w-6xl px-6">
        <div className="flex flex-col items-center mb-16">
          <CodeIcon className="w-8 h-8 text-codehouzeOrange mb-4" />
          <h2 className="text-3xl sm:text-4xl font-bold text-white">What We Do</h2>
          <div className="codehouze-divider" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {services.map(({ icon: Icon, title, description, span }, i) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`group relative p-6 rounded-2xl bg-white/[0.03] border border-white/10 hover:border-codehouzeOrange/40 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-codehouzeOrange/5 ${span}`}
            >
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-codehouzeMaroon to-codehouzeOrange flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <Icon className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-white font-semibold text-lg mb-2">{title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CodehouzeServices;
